import { gsap } from '../global/gsap';

const initOverlay = (triggers) => {

    const body = document.querySelector('body');
    const overlayContainer = document.querySelector('.js-overlay');
    const overlayTarget = document.querySelector('.js-overlay-target');
    
    let loader = null;
    if(overlayContainer) {
        loader = overlayContainer.querySelector('.js-loader');
    }

    const loaderTL = gsap.timeline({repeat: -1});

    loaderTL.to(loader, { rotation: 90, duration: .8, ease: 'power4.inOut' });

    gsap.set(overlayContainer, { autoAlpha: 0 });
    
    const openOverlay = (src) => {

        gsap.set(overlayContainer, {
            autoAlpha: 0,
        })

        gsap.to(overlayContainer, {
            autoAlpha: 1,
            pointerEvents: 'all',
            duration: .4
        })

        gsap.set(loader, {
            autoAlpha: 1
        })
        overlayTarget.innerHTML = '';

        fetch(src).then((response) => response.text()).then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const content = doc.querySelector('.js-overlay-content');

            if (content) {
                overlayTarget.appendChild(content);
                return doc;
            }

            return null;

        }).then((doc) => {

            gsap.set(loader, {
                autoAlpha: 1,
            })

            gsap.set(overlayTarget, {
                autoAlpha: 0,
                yPercent: 20
            })

            gsap.to(loader, {
                autoAlpha: 0,
                duration: .2,
                onComplete: () => {
                    gsap.to(overlayTarget, {
                        yPercent: 0,
                        autoAlpha: 1,
                        duration: .375,
                        ease: 'power2.inOut'
                    })
                }
            })

            const closeButtons = overlayContainer.querySelectorAll('.js-overlay-close');

            if (closeButtons && closeButtons.length > 0) {
                closeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        closeOverlay();
                    })
                })
            };


            
            
        }).catch(err => {
            closeOverlay();
        })
    }

    const closeOverlay = () => {
        body.classList.remove('stop-scrolling');
        overlayTarget.innerHTML = '';

        gsap.set(loader, {
            opacity: 1
        });

        gsap.to(overlayContainer, {autoAlpha: 0, duration: 0})
    }

    triggers.forEach(trigger => {
        const dataSrc = trigger.dataset.src;

        trigger.addEventListener('click', () => {
            body.classList.add('stop-scrolling');
            openOverlay(dataSrc);
        })
    })

}

export default initOverlay;